<template>
	<div class="hallMain">
		<div class="iconfont" @click="gobackapp">&#xe618;</div>
		<div class="otitle">开奖信息</div>
	</div>
	<div class="hallList">
		<div 
			v-for="(item,index) in hallData"
			class="ssq-dlt" 
			:class="item.className"
			@click="jumpdetails(item.lotteryNo,item.issue)"
		>
			<div class="modeltop">
				<span class="lotname">{{item.lotteryName}}</span>
				<span class="issues">{{item.issue}}期</span>
				<span class="dates">{{item.ernieDateStr}}</span>
			</div>
			<!-- 3d -->
			<div class="fcbot-3d" v-if="item.lotteryNo=='002'">
				<ul class="kjgg-3d">
					<li class="kjred" v-for="v in item.redball">{{v}}</li>
				</ul>
				<ul class="shijinumber">
					<li class="shijiname">试机号</li>
					<li class="kjgrey" v-for="s in item.tryoutNumber">{{s}}</li>
				</ul>
				<div class="iconfont right">&#xe615;</div>
			</div>
			<!-- 半全场 \ 胜负任九 \ 进球彩-->
			<div class="fcbot" v-else-if="item.lotteryNo=='300'||item.lotteryNo=='302'||item.lotteryNo=='303'">
				<ul class="kjgg-fangk">
					<li class="kjred" v-for="f in item.redball">{{f}}</li>
				</ul>
				<div class="iconfont right">&#xe615;</div>
			</div>
			<!-- 竞彩 -->
			<div class="fcbot" v-else-if="item.lotteryNo=='201'||item.lotteryNo=='200'||item.lotteryNo=='400'">
				<div :class="item.lotteryNo=='200'?'kjimghs':'kjimglvs'"></div>
				<div class="iconfont right">&#xe615;</div>
			</div>
			<!-- 其他 -->
			<div class="fcbot" v-else>
				<ul class="kjgg">
					<li class="kjred" v-for="q in item.redball">{{q}}</li>
					<li class="kjbule" v-if="item.blueball.length!==0" v-for="vb in item.blueball">{{vb}}</li>
				</ul>
				<div class="iconfont right">&#xe615;</div>
			</div>
			
			<div class="jumpmodel" v-if="item.lotteryNo!=='201'&&item.lotteryNo!=='200'&&item.lotteryNo!=='400'">
				<span v-if="item.lotteryNo=='001'||item.lotteryNo=='113'||item.lotteryNo=='108'||item.lotteryNo=='002'" @click.stop="appjump('expert',item.lotteryNo)">专家推荐</span>
				<span v-if="item.lotteryNo=='001'||item.lotteryNo=='113'||item.lotteryNo=='108'||item.lotteryNo=='002'||item.lotteryNo=='109'||item.lotteryNo=='300'||item.lotteryNo=='110'||item.lotteryNo=='003'||item.lotteryNo=='302'||item.lotteryNo=='303'" @click.stop="h5jumphist(item.lotteryNo)">历史开奖</span>
			</div>
		</div>
		
	</div>
</template>

<script>
	import { getList } from '@/hooks/useHallList'
	import { getCurrentInstance,ref } from 'vue'
	import { useRouter } from 'vue-router'
	
	export default{
		name: 'Hall',
		setup() {
			
			const baseUrl = getCurrentInstance().appContext.config.globalProperties.axiosurl
			const router = useRouter()
			let hallData = ref(null)
			getList(baseUrl).then(value => {
				hallData.value = value
			})
			const gobackapp = ()=>{
				window.location.href="/"
			}
			const appjump = (lotname,lotid) => {
				window.location.href = `/module/zcwh5/expert/szcRecommend.jsp?lcode=${lotid}`
			}
			const jumpdetails = (lotid,issue) => {
				if(lotid=='201'||lotid=='200'||lotid=='400'){
					router.push({name:'Jcdetail',params:{lotid:lotid,issue:issue}})
				}else{
					router.push({name:'Detail',params:{lotid:lotid,issue:issue}})
				}
			}
			const h5jumphist = (lotid)=>{
				router.push({name:'History',params:{lotid:lotid}})
			}
			
			return {
				hallData,
				appjump,
				jumpdetails,
				h5jumphist,
				gobackapp
			}
		}
	}
</script>

<style scoped="scoped">
	.hallMain{position:relative;width:3.75rem;height:.44rem;color:#42B983;background-color: #FFFFFF;padding:0 .15rem 0 .1rem;box-sizing: border-box;}
	.hallMain .iconfont{width:.2rem;height:.2rem;color:#333333;font-size: .18rem;position: absolute;left:.15rem;top:.12rem;}
	.otitle{width:100%;height:100%;text-align: center;font-size:.18rem;color:#333333;font-weight: bold;line-height: .44rem;}
	.zhuduijiang{font-size:.15rem;color:#333333;position: absolute;right:.15rem;top:.12rem;}
	
	.hallList{width:100%;background:#F4F4F4;padding:0 .1rem .1rem .1rem;box-sizing: border-box;display:flex;flex-direction: column;align-items: center;}
	.hallList .ssq-dlt{width:3.55rem;height:1.45rem;margin-top:.1rem;display:flex;flex-direction: column;background: #FFFFFF;border-radius: .04rem;padding:.15rem;box-sizing: border-box;}
	.hallList .ssq-dlt.jingcai{height:1.02rem;}
	.modeltop{width:100%;display: flex;flex-direction: row;align-items: center;}
	.lotname{font-size: .18rem;color:#333333;margin-right:.1rem;font-weight: bold;margin-top:.05rem;}
	.issues{font-size:.12rem;color:#333333;margin-right:.05rem;}
	.dates{font-size:.12rem;color:#999999;}
	
	.fcbot{width:100%;height: .6rem;display: flex;flex-direction: row;justify-content: space-between;align-items: center;}
	.fcbot .kjgg{width: 3rem;height: 100%;display: flex;flex-direction: row;align-items: center;}
	.fcbot .kjgg li{text-align: center;line-height: .3rem;width: .3rem;margin-right:.06rem;height: .3rem;font-size: .14rem;border-radius: 50%;-webkit-border-radius: 50%;-moz-border-radius: 50%;-ms-border-radius: 50%;-o-border-radius: 50%;}
	.fcbot .kjgg li.kjred {background: #F44444;color: #fff;}
	.fcbot .kjgg li.kjbule {background: #2E9FFE;color: #fff;}
	.right{width:.13rem;height:.2rem;font-size: .2rem;}
	
	.jumpmodel{width:100%;height:.3rem;display: flex;flex-direction: row-reverse;align-items: center;}
	.jumpmodel span{width:.75rem;height:.26rem;background:#FFEBEB;border-radius: .03rem;color:#E81C1A;font-size:.13rem;margin-left:.1rem;line-height: .26rem;text-align: center;}
	.jumpmodel span:last-child{margin-left:0;}
	
	.hallList .fuc3d{width:3.55rem;height:1.45rem;margin-top:.1rem;display:flex;flex-direction: column;background: #FFFFFF;border-radius: .04rem;padding:.15rem;box-sizing: border-box;}
	.fcbot-3d{width:100%;height: .6rem;display: flex;flex-direction: row;align-items: center;}
	.kjgg-3d{display:flex;flex-direction: row;align-items: center;width:1.4rem;}
	.kjgg-3d li{margin-right:.06rem;text-align: center;line-height: .3rem;width: .3rem;height: .3rem;font-size: .14rem;border-radius: 50%;-webkit-border-radius: 50%;-moz-border-radius: 50%;-ms-border-radius: 50%;-o-border-radius: 50%;}
	.kjgg-3d li.kjred {background: #F44444;color: #fff;}
	.shijinumber{display:flex;flex-direction: row;align-items: center;width: 1.7rem;}
	.shijiname{font-size:.13rem;color:#999999;margin-right:.09rem;}
	.shijinumber .kjgrey{width: .3rem;height: .3rem;background: #E8E9ED;text-align: center;line-height: .3rem;border-radius: 50%;margin-right:.06rem;}
	.kjgg-fangk{width: 2.85rem;height: 100%;display: flex;flex-direction: row;align-items: center;}
	.kjgg-fangk li{background: #F44444;color: #fff;text-align: center;line-height: .32rem;width: .2rem;margin-right:.06rem;height: .32rem;font-size: .14rem;border-radius: .01rem;-webkit-border-radius: .01rem;-moz-border-radius: .01rem;-ms-border-radius: .01rem;-o-border-radius: .01rem;}
	
	.fcbot .kjimglvs{width:.9rem;height:.28rem;background:url('~imgs/greenback.png') no-repeat;background-size:100% 100%;}
	.fcbot .kjimghs{width:.9rem;height:.28rem;background:url('~imgs/yellowback.png') no-repeat;background-size:100% 100%;}
</style>
